"use client";

import { useAuth } from "@/context/AuthContext";
import { useRouter } from "next/navigation";

export default function Protected({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const router = useRouter();

  if (!user) {
    router.push("/sign-in");
    return <></>;
  }

  return <>{children}</>;
}
